import { Component, OnInit , Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrganizationService } from '../../services/organization.service'; 

@Component({
  selector: 'app-unarchive-inactive-popup',
  templateUrl: './unarchive-inactive-popup.component.html',
  styleUrls: ['./unarchive-inactive-popup.component.css']
})
export class UnarchiveInactivePopupComponent implements OnInit {
  public title: string
  public organizations = [];
  public selectedOrganization;
  public selectedLegalEntity;
  public selectedSite;
  public currentDate = new Date();
  public contractEndDate: any;
  public contractStartDate: any;
  public legalEntities: any;
  public sites;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<UnarchiveInactivePopupComponent>,
  public organizationService: OrganizationService) { }

  ngOnInit() {
    // all sites
    this.organizationService.getAllSites().subscribe((data) => {
      this.sites = Object.assign([],data['sites']);
  }, (error) => {
  });
  // ---------------------------
    this.organizationService.getAllLegalEntitiesCompanyContext(null).subscribe(entities => {
      this.legalEntities = entities;
    }, err => {
      console.log(err);
    });
    if (this.data != null ) {
      this.title = this.data.title;
      this.organizations = this.data.organizations;
    }
  }

  cancel() {
    this.dialogRef.close('Cancel');
  }

  proceed() {
    this.dialogRef.close({'organization': this.selectedOrganization, 'legalEntity': this.selectedLegalEntity,
    'site': this.selectedSite, 'contractEndDate': this.contractEndDate, 'contractStartDate': this.contractStartDate });
  }

}
